import React from 'react';
import moment from 'moment';

const ReservationGuestsDetails = ({ reservation }) => {
  return (
    <table className="table table-bordered table-striped details">
      <thead>
        <tr className="info">
          <th colSpan="2">
            Guests details
            &nbsp;
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Adults</td>
          <td>{ reservation.nb_adults || 0 }</td>
        </tr>
        <tr>
          <td>Young adults</td>
          <td>{ reservation.nb_young_adults || 0 }</td>
        </tr>
        <tr>
          <td>Children</td>
          <td>{ reservation.nb_children || 0 }</td>
        </tr>
        <tr>
          <td>Young children</td>
          <td>{ reservation.nb_young_children || 0 }</td>
        </tr>
        <tr>
          <td>Babies</td>
          <td>{ reservation.nb_babies || 0 }</td>
        </tr>
      </tbody>
    </table>
  );
};

export default ReservationGuestsDetails;



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/common/ReservationGuestsDetails.jsx